import { IonButton, IonIcon } from '@ionic/react';
import { syncOutline, closeOutline } from 'ionicons/icons';
import React from 'react';

interface LinkPlayerResultModalProps {
  type: 'success' | 'error';
  onContinue: () => void;
  onTryAgain: () => void;
}

const LinkPlayerResultModal: React.FC<LinkPlayerResultModalProps> = ({
  type,
  onContinue,
  onTryAgain,
}) => {
  const isSuccess = type === 'success';

  return (
    <div className="link-player-result-overlay">
      <div className="link-player-result-card">
        <IonIcon
          icon={isSuccess ? syncOutline : closeOutline}
          className="link-player-result-card__icon"
        />
        <h2 className="link-player-result-card__title">
          {isSuccess ? 'Linking Account...' : 'Sorry something went wrong...'}
        </h2>
        <p className="link-player-result-card__subtitle">
          {isSuccess
            ? "This may take a few minutes... we will notify you when you're verified"
            : 'Please verify the information submitted and try again. If the issue persists see your casinos front desk'}
        </p>
        <div className="link-player-result-card__actions">
          {isSuccess ? (
            <IonButton expand="block" className="link-player-result-card__btn--primary" onClick={onContinue}>
              CONTINUE
            </IonButton>
          ) : (
            <>
              {/* <IonButton
                expand="block"
                fill="clear"
                className="link-player-result-card__btn--secondary"
                onClick={onContinue}
              >
                DISMISS
              </IonButton> */}
              <IonButton
                expand="block"
                className="link-player-result-card__btn--primary"
                onClick={onTryAgain}
              >
                TRY AGAIN
              </IonButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LinkPlayerResultModal;
